import { Injectable } from '@angular/core';
import { AppState } from '../models/app.state';
import { Store } from '@ngrx/store';
import { Filter, FilterType, GeoFilter } from '../models/Filter';
import * as filterActions from '../actions/filter.actions';
import { LocationService } from "./geolocation.service";
import { JqueryHelperService } from "../jquery-helper.service";


@Injectable()
export class FilterService {

  constructor(private store: Store<AppState>,
    private locationService: LocationService) { }

  getActiveFilteres() {
    return this.store.select((store) => store.filters);
  }

  removeFilter(filter: Filter) {
    this.store.dispatch(new filterActions.RemoveFilterAction(filter));
  }

  addFilter(filterName: string, type: FilterType) {
    const filter = new Filter(type, true, filterName);
    this.store.dispatch(new filterActions.AddFilterAction(filter));
  }

  addPriceFilter(minPrice: number, maxPrice: number) {
    const filter = new Filter(FilterType.PRICE, true, { minPrice, maxPrice });
    this.store.dispatch(new filterActions.AddFilterAction(filter));
  }

  search(filterName: string) {
    if (filterName) {
      const filter = new Filter(FilterType.SEARCH, true, filterName);
      this.store.dispatch(new filterActions.AddFilterAction(filter));
    }
  }

  location: Coordinates;
  addDistanceFilter(distance: number) {
    if (this.locationService.userCoords) {
      this.location = this.locationService.userCoords;
      const filterValue = <GeoFilter>{
        radius: distance,
        latitude: this.location.latitude,
        longitude: this.location.longitude
      };

      const filter = new Filter(FilterType.GEO, true, filterValue);
      this.store.dispatch(new filterActions.AddFilterAction(filter));
    }
  }

  // addDistanceFilter(distance: number) {
  //   if (this.location) {
  //     const filterValue = <GeoFilter>{
  //       radius: distance,
  //       latitude: this.location.latitude,
  //       longitude: this.location.longitude
  //     };
  //     const filter = new Filter(FilterType.GEO, true, filterValue);
  //     this.store.dispatch(new filterActions.AddFilterAction(filter));
  //   } else {

  //     if (navigator.geolocation) {
  //       // console.log('NAVIGATOR');
  //       navigator.geolocation.getCurrentPosition(position => {
  //         // console.log('CURRENT POSITION: ', position.coords);
  //         // this.locationAllowed = true;
  //         this.location = position.coords;
  //         const filterValue = <GeoFilter>{
  //           radius: distance,
  //           latitude: position.coords.latitude,
  //           longitude: position.coords.longitude
  //         };

  //         const filter = new Filter(FilterType.GEO, true, filterValue);
  //         this.store.dispatch(new filterActions.AddFilterAction(filter));
  //       });

  //     }
  //   }
  // }
}






// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/shared/filter.service.ts